import React, { useState, useEffect } from "react";
import { getTopBatters, getTopBowlers, getTopScores } from "../services/StatsService";
import { getTeams } from "../services/TeamService";
import TopRunScorers from "../components/stats/TopRunScorers";
import TopWicketTakers from "../components/stats/TopWicketTakers";
import HighestTeamScores from "../components/stats/HighestTeamScores";
import HeadToHead from "../components/stats/HeadToHead";

function Stats() {
    const [activeFilter, setActiveFilter] = useState("all");
    const [topBatters, setTopBatters] = useState([]);
    const [topBowlers, setTopBowlers] = useState([]);
    const [topScores, setTopScores] = useState([]);
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats("all");
        fetchTeams();
    }, []);

    const fetchTeams = async () => {
        try {
            const data = await getTeams();
            if (data?.teams) setTeams(data.teams);
        } catch (err) {
            console.error("Teams fetch error", err);
        }
    };

    const fetchStats = async (range) => {
        setLoading(true);
        try {
            const [battersRes, bowlersRes, scoresRes] = await Promise.all([
                getTopBatters(0, 10, range),
                getTopBowlers(0, 10, range),
                getTopScores(0, 10, range)
            ]);
            if (battersRes?.players) setTopBatters(battersRes.players);
            if (bowlersRes?.players) setTopBowlers(bowlersRes.players);
            if (scoresRes?.matches) setTopScores(scoresRes.matches);
        } catch (err) {
            console.error("Stats fetch error", err);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (filter, range) => {
        setActiveFilter(filter);
        fetchStats(range);
    };

    return (
        <div id="section-stats" className="spanel active">
            <div className="main-wrap main-wrap-padded">
                {/*<div className="fbar">*/}
                {/*    <button className={`fbtn ${activeFilter === "today" ? "active" : ""}`} onClick={() => handleFilterChange("today", "today")}>Today</button>*/}
                {/*    <button className={`fbtn ${activeFilter === "week" ? "active" : ""}`} onClick={() => handleFilterChange("week", "week")}>This Week</button>*/}
                {/*    <button className={`fbtn ${activeFilter === "all" ? "active" : ""}`} onClick={() => handleFilterChange("all", "all")}>All Time</button>*/}
                {/*</div>*/}

                <div className="s2col">
                    <TopRunScorers players={topBatters} loading={loading} />
                    <TopWicketTakers players={topBowlers} loading={loading} />
                </div>

                <div className="sh">Highest Team Scores - Last Week</div>
                <HighestTeamScores matches={topScores} loading={loading} />

                <div className="sh sh-mt">Head to Head - Last Week</div>
                <HeadToHead teams={teams} />
            </div>
        </div>
    );
}

export default Stats;